import { render, staticRenderFns } from "./LayoutCover.vue?vue&type=template&id=ed766612&scoped=true"
import script from "./LayoutCover.vue?vue&type=script&lang=js"
export * from "./LayoutCover.vue?vue&type=script&lang=js"
import style0 from "./LayoutCover.vue?vue&type=style&index=0&id=ed766612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed766612",
  null
  
)

export default component.exports